import { useQuery } from "react-query";
import { namesUseQuery } from "../../utils/constants";
import { PersonService } from "../../services/PersonService";

export function useCountPersons() {
  const { data, isLoading } = useQuery(
    [namesUseQuery?.GET_COUNT_PERSONS],
    () => PersonService.getCountRegisters(),
    {
      onError: (error) => {
        console.log(error);
      },
    }
  );

  return {
    data: data,
    isLoading,
  };
}
